import { render, staticRenderFns } from "./Block2Income.vue?vue&type=template&id=0e4a245d"
import script from "./Block2Income.vue?vue&type=script&lang=ts"
export * from "./Block2Income.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports